<template>
  <v-row class="filters--list mb-4">
    <v-col cols="12" sm="4" md="2" lg="2">
      <FilterSearch
        :fetchData="fetchRechargesAdmin"
        searchTerm="code"
        label="code"
        type="number"
      />
    </v-col>
    <v-col cols="12" sm="8" md="4" lg="4">
      <FilterAutocomplete
        :fetchData="fetchRechargesAdmin"
        :items="realEstateList"
        :label="$t('filters.realEstate')"
        type="realEstateIds"
        value="id"
      />
    </v-col>
    <v-col cols="12" sm="8" md="3" lg="2">
      <FilterSelect
        :fetchData="fetchRechargesAdmin"
        :items="[
          { label: $t(`recharge.status.PENDING`), value: 'PENDING' },
          { label: $t(`recharge.status.RECEIVED`), value: 'RECEIVED' },
          { label: $t(`recharge.status.CONFIRMED`), value: 'CONFIRMED' },
        ]"
        item-text="label"
        item-value="value"
        label="Status"
        type="status"
      />
    </v-col>
    <v-col cols="12" sm="12" md="3" lg="2">
      <FilterDates :fetchData="fetchRechargesAdmin" :dateRange="true" />
    </v-col>
  </v-row>
</template>

<script>
import FilterAutocomplete from '@/components/filters/FilterAutocomplete'
import FilterSearch from '@/components/filters/FilterSearch'
import FilterDates from '@/components/filters/FilterDates'
import FilterSelect from '@/components/filters/FilterSelect'

import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'RechargeListFiltersAdmin',

  components: { FilterAutocomplete, FilterSelect, FilterSearch, FilterDates },

  computed: {
    ...mapGetters(['isLoading', 'realEstateList']),
  },

  methods: {
    ...mapActions(['fetchRechargesAdmin', 'realEstateSearch']),
  },

  mounted() {
    this.realEstateSearch()
  },
}
</script>
